module.exports = __webpack_public_path__ + "static/media/wolf-gold.90e8104c.gif";